import { Role } from './role';

export class User {
  id: number;
  img: string;
  photo?: string;
  username: string;
  password: string;
  firstName: string;
  nom?:string;
  prenom?:string;
  lastName: string;
  filiale_id?: number;
  filiale_libelle?:string;
  role: Role;
  role_id?: number;
  token: string;
  access_token?: string;
  refresh_token?: string;
  token_type?: string;
  expires_in?: number;
  login?: string;
  type_user_codification?: string;
  is_default_password?: number;
  uniteFoncActiveId?:string;
  adminUniteFonctionnelleCode?:string;
  uniteFonctionnelles?:any[];
  fonctionnalites?:any[]
}
